import { FC, PropsWithChildren } from 'react';
import { DrawerStyles } from 'antd/es/drawer/DrawerPanel';
import styled from 'styled-components';

import { Drawer } from '@/features/vfo/uikit/Drawer';
import { COLORS } from '@/shared/constants/colors';
import { Icon } from '@/shared/uikit/Icon';
import { Title } from '@/shared/uikit/Title';
import { useModalsStore } from '@/widgets/modals/modals.store';

export type ModalContainerProps = {
  title: string;
  onClose?: () => void;
} & PropsWithChildren;

const DRAWER_STYLES: DrawerStyles = {
  wrapper: {
    borderRadius: '16px 16px 0 0',
    overflow: 'hidden',
  },
};

export const VfoModalContainerV5: FC<ModalContainerProps> = ({ title, onClose, children }) => {
  const { closeModal } = useModalsStore();

  return (
    <DrawerStyled
      open
      placement="bottom"
      height="auto"
      closable
      onClose={onClose ?? closeModal}
      styles={DRAWER_STYLES}
      title={
        <Title bold size={16} style={{ color: COLORS.systemDark300 }}>
          {title}
        </Title>
      }
      closeIcon={<Icon name="x" size="s16" />}
    >
      {children}
    </DrawerStyled>
  );
};

const DrawerStyled = styled(Drawer)`
  &&& {
    .ant-drawer-header {
      padding: 16px 24px;
      border-bottom: none;
    }

    .ant-drawer-close {
      order: 1;
      margin: 0;
    }

    .ant-drawer-body {
      padding: 24px;
    }
  }
`;
